import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { personalInfo } from '../../data/content';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-darker text-slate-300 py-16 px-6 md:px-12 border-t-4 border-brand-red relative overflow-hidden">
      <div 
        className="absolute inset-0 opacity-[0.05] pointer-events-none" 
        style={{ 
          backgroundImage: 'linear-gradient(to right, #40E0D0 1px, transparent 1px), linear-gradient(to bottom, #40E0D0 1px, transparent 1px)', 
          backgroundSize: '48px 48px',
          maskImage: 'radial-gradient(circle at center, transparent 0%, black 80%)',
          WebkitMaskImage: 'radial-gradient(circle at center, transparent 0%, black 80%)'
        }}
      ></div>
      
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12 relative z-10">
        <div className="col-span-1 md:col-span-2 space-y-6">
          <Link to="/" className="inline-block group mb-4 ml-2">
            <div className="shrink-0 relative w-10 h-10 flex items-center justify-center">
              <div className="absolute inset-[-12px] border-2 border-brand-red/20 rounded-full group-hover:scale-110 transition-transform duration-500"></div>
              <div className="absolute inset-[-6px] border-2 border-brand-red/40 rounded-full group-hover:scale-105 transition-transform duration-500"></div>
              <div className="absolute inset-0 bg-brand-red rounded-full group-hover:bg-brand-cyan transition-colors z-0 shadow-lg"></div>
              <img 
                src="https://media-manager-c.questera.ai/greta-media/fb12f51ee5b6b5b04fc36e6e38322fdbe9f21a5255319993208ee42085da62af087180258d5c6d79d895c821bb9cc720/images/aW1hZ2UvcG5n/f8ab48ab4bf85403ccf7fcbba8dbb012.png" 
                alt="Julie Adams Logo" 
                className="relative z-20 w-[180%] h-[180%] max-w-none object-contain drop-shadow-xl transition-transform group-hover:scale-110"
              />
            </div>
          </Link>
          <p className="text-sm leading-relaxed max-w-md text-slate-400">
            {personalInfo.title}. {personalInfo.headline}. Platform Delivery Consultant.
          </p>
          <div className="flex items-center gap-4 pt-2">
            <a href={personalInfo.linkedin} target="_blank" rel="noopener noreferrer" className="hover:text-brand-cyan transition-colors p-2 rounded-full hover:bg-slate-800">
              <SafeIcon name="Linkedin" className="w-5 h-5" />
            </a>
            <a href="https://www.youtube.com/@SEVENHATSConsulting" target="_blank" rel="noopener noreferrer" className="hover:text-brand-cyan transition-colors p-2 rounded-full hover:bg-slate-800">
              <SafeIcon name="Youtube" className="w-5 h-5" />
            </a>
            <a href={`mailto:${personalInfo.email}`} className="hover:text-brand-cyan transition-colors p-2 rounded-full hover:bg-slate-800">
              <SafeIcon name="Mail" className="w-5 h-5" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-white font-heading tracking-widest uppercase text-sm mb-6 font-bold">Navigation</h4>
          <ul className="space-y-3">
            <li><Link to="/work-with-me" className="text-sm hover:text-brand-yellow transition-colors">Work With Me</Link></li>
            <li><Link to="/fractional-cmo" className="text-sm hover:text-brand-yellow transition-colors">Services</Link></li>
            <li><Link to="/resources" className="text-sm hover:text-brand-yellow transition-colors">Resources</Link></li>
            <li><Link to="/about" className="text-sm hover:text-brand-yellow transition-colors">About</Link></li>
            <li><Link to="/contact" className="text-sm hover:text-brand-yellow transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-heading tracking-widest uppercase text-sm mb-6 font-bold">Ventures</h4>
          <ul className="space-y-3">
            <li>
              <a href={personalInfo.agency} target="_blank" rel="noopener noreferrer" className="text-sm hover:text-brand-yellow transition-colors flex items-center gap-2">
                SEVEN HATS® <SafeIcon name="ExternalLink" className="w-3 h-3" />
              </a>
            </li>
            <li>
              <a href={personalInfo.jacMarketing} target="_blank" rel="noopener noreferrer" className="text-sm hover:text-brand-yellow transition-colors flex items-center gap-2">
                JAC Marketing <SafeIcon name="ExternalLink" className="w-3 h-3" />
              </a>
            </li>
            <li>
              <a href="https://a.co/d/0aFd8xuc" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-brand-yellow transition-colors flex items-center gap-2">
                Brand Like A Girl <SafeIcon name="BookOpen" className="w-3 h-3" />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4 relative z-10">
        <p className="text-xs text-slate-500">
          &copy; {currentYear} Julie Adams. All rights reserved.
        </p>
        <p className="text-xs text-brand-cyan font-bold tracking-widest uppercase">
          Designing for strategic impact.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
